/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CursorPaginatedResponseFormQueryV1Dto } from '../models/cursor-paginated-response-form-query-v-1-dto';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { FormCreateQueryDtov1 } from '../models/form-create-query-dtov-1';
import { FormQueryV1 } from '../models/form-query-v-1';
import { FormTypeUpdateDtov1 } from '../models/form-type-update-dtov-1';


/**
 * API for browse and manage forms.
 */
@Injectable({
  providedIn: 'root',
})
export class FormService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listForms
   */
  static readonly ListFormsPath = '/v1/forms';

  /**
   * List all forms.
   *
   * Returns all forms that haven't been deleted (includes deactivated forms).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForms$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<FormQueryV1>>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.ListFormsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FormQueryV1>>;
      })
    );
  }

  /**
   * List all forms.
   *
   * Returns all forms that haven't been deleted (includes deactivated forms).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForms(params?: {
  },
  context?: HttpContext

): Observable<Array<FormQueryV1>> {

    return this.listForms$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<FormQueryV1>>) => r.body as Array<FormQueryV1>)
    );
  }

  /**
   * Path part for operation createForm
   */
  static readonly CreateFormPath = '/v1/forms';

  /**
   * Create new form.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createForm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createForm$Response(params: {

    /**
     * Payload for creating a new form
     */
    body: FormCreateQueryDtov1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.CreateFormPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormQueryV1>;
      })
    );
  }

  /**
   * Create new form.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createForm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createForm(params: {

    /**
     * Payload for creating a new form
     */
    body: FormCreateQueryDtov1
  },
  context?: HttpContext

): Observable<FormQueryV1> {

    return this.createForm$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormQueryV1>) => r.body as FormQueryV1)
    );
  }

  /**
   * Path part for operation updateFormType
   */
  static readonly UpdateFormTypePath = '/v1/forms/{formId}/type';

  /**
   * Change a form's type.
   *
   * Changes a form's type. When a request using an OFFBOARDING form reaches full approval, SLM automatically deactivates the supplier and its users, and cancels the supplier's other cancellable requests.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormType$Response(params: {
    formId: string;

    /**
     * The new type value
     */
    body: FormTypeUpdateDtov1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.UpdateFormTypePath, 'post');
    if (params) {
      rb.path('formId', params.formId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormQueryV1>;
      })
    );
  }

  /**
   * Change a form's type.
   *
   * Changes a form's type. When a request using an OFFBOARDING form reaches full approval, SLM automatically deactivates the supplier and its users, and cancels the supplier's other cancellable requests.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormType(params: {
    formId: string;

    /**
     * The new type value
     */
    body: FormTypeUpdateDtov1
  },
  context?: HttpContext

): Observable<FormQueryV1> {

    return this.updateFormType$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormQueryV1>) => r.body as FormQueryV1)
    );
  }

  /**
   * Path part for operation deactivateFormV1
   */
  static readonly DeactivateFormV1Path = '/v1/forms/{formId}/deactivate';

  /**
   * Deactivate a form template.
   *
   * Deactivates a form template, preventing its use in new supplier requests. Existing requests using this form are not affected. Idempotent: returns success if form is already deactivated.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateFormV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateFormV1$Response(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.DeactivateFormV1Path, 'post');
    if (params) {
      rb.path('formId', params.formId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormQueryV1>;
      })
    );
  }

  /**
   * Deactivate a form template.
   *
   * Deactivates a form template, preventing its use in new supplier requests. Existing requests using this form are not affected. Idempotent: returns success if form is already deactivated.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deactivateFormV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateFormV1(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<FormQueryV1> {

    return this.deactivateFormV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormQueryV1>) => r.body as FormQueryV1)
    );
  }

  /**
   * Path part for operation activateFormV1
   */
  static readonly ActivateFormV1Path = '/v1/forms/{formId}/activate';

  /**
   * Activate a previously deactivated form template.
   *
   * Activates a previously deactivated form template, making it available for use in new supplier requests. Idempotent: returns success if form is already active.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateFormV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateFormV1$Response(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.ActivateFormV1Path, 'post');
    if (params) {
      rb.path('formId', params.formId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormQueryV1>;
      })
    );
  }

  /**
   * Activate a previously deactivated form template.
   *
   * Activates a previously deactivated form template, making it available for use in new supplier requests. Idempotent: returns success if form is already active.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activateFormV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activateFormV1(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<FormQueryV1> {

    return this.activateFormV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormQueryV1>) => r.body as FormQueryV1)
    );
  }

  /**
   * Path part for operation listFormsCursor
   */
  static readonly ListFormsCursorPath = '/v1/forms/cursor-list';

  /**
   * List forms using cursor-based pagination.
   *
   * Retrieves non-deleted forms using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFormsCursor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listFormsCursor$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseFormQueryV1Dto>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.ListFormsCursorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseFormQueryV1Dto>;
      })
    );
  }

  /**
   * List forms using cursor-based pagination.
   *
   * Retrieves non-deleted forms using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFormsCursor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listFormsCursor(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseFormQueryV1Dto> {

    return this.listFormsCursor$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseFormQueryV1Dto>) => r.body as CursorPaginatedResponseFormQueryV1Dto)
    );
  }

  /**
   * Path part for operation getFormById
   */
  static readonly GetFormByIdPath = '/v1/forms/{formId}';

  /**
   * Get form by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormById$Response(params: {
    formId: string;
    audit?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FormQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.GetFormByIdPath, 'get');
    if (params) {
      rb.path('formId', params.formId, {});
      rb.query('audit', params.audit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormQueryV1>;
      })
    );
  }

  /**
   * Get form by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFormById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormById(params: {
    formId: string;
    audit?: boolean;
  },
  context?: HttpContext

): Observable<FormQueryV1> {

    return this.getFormById$Response(params,context).pipe(
      map((r: StrictHttpResponse<FormQueryV1>) => r.body as FormQueryV1)
    );
  }

  /**
   * Path part for operation deleteForm
   */
  static readonly DeleteFormPath = '/v1/forms/{formId}';

  /**
   * Delete a form.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteForm()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteForm$Response(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.DeleteFormPath, 'delete');
    if (params) {
      rb.path('formId', params.formId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        [key: string]: string;
        }>;
      })
    );
  }

  /**
   * Delete a form.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteForm$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteForm(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<{
[key: string]: string;
}> {

    return this.deleteForm$Response(params,context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>) => r.body as {
[key: string]: string;
})
    );
  }

  /**
   * Path part for operation listActiveForms
   */
  static readonly ListActiveFormsPath = '/v1/forms/active';

  /**
   * List all active forms.
   *
   * Returns only active forms (not deleted and not deactivated).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActiveForms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActiveForms$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<FormQueryV1>>> {

    const rb = new RequestBuilder(this.rootUrl, FormService.ListActiveFormsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FormQueryV1>>;
      })
    );
  }

  /**
   * List all active forms.
   *
   * Returns only active forms (not deleted and not deactivated).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActiveForms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActiveForms(params?: {
  },
  context?: HttpContext

): Observable<Array<FormQueryV1>> {

    return this.listActiveForms$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<FormQueryV1>>) => r.body as Array<FormQueryV1>)
    );
  }

}
